export default __webpack_public_path__ + "static/media/product_pref2.06cb5f990705699f0dae4611e1610d43.svg";